import { render, staticRenderFns } from "./SecretaryManager.vue?vue&type=template&id=3fcd6a5c&scoped=true&"
import script from "./SecretaryManager.vue?vue&type=script&lang=js&"
export * from "./SecretaryManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd6a5c",
  null
  
)

export default component.exports